export default __webpack_public_path__ + "static/media/image5.6547c679.jpg";